import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NodeType } from '../../shared-services/pipeline-workflow.model';

@Component({
  selector: 'app-pipeline-node-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="pipeline-badge"
          [class.badge-auto]="type === 'AUTO_APPROVE'"
          [class.badge-parallel]="type === 'PARALLEL'"
          [class.badge-hierarchy]="type === 'HIERARCHY'"
          [class.size-sm]="size === 'sm'"
          [class.size-md]="size === 'md'">
      {{ label }}
    </span>
  `,
  styles: [`
    .pipeline-badge {
      display: inline-flex; align-items: center;
      font-weight: 700; border-radius: 4px; letter-spacing: 0.03em; white-space: nowrap;
    }
    .size-sm { font-size: 9px; padding: 2px 7px; }
    .size-md { font-size: 11px; padding: 3px 10px; }
    .badge-auto, .badge-hierarchy {
      background: var(--bg-hover, #f0f0ec); color: var(--text-main, #111);
    }
    .badge-parallel {
      background: var(--primary-bg, rgba(4,61,99,.08)); color: var(--primary, #043D63);
    }
  `],
})
export class PipelineNodeBadgeComponent {
  @Input() type: NodeType = 'AUTO_APPROVE';
  @Input() size: 'sm' | 'md' = 'sm';
  @Input() customLabel: string | null = null;

  get label(): string {
    const label = this.customLabel?.trim();
    if (label) return label;

    const map: Record<NodeType, string> = {
      AUTO_APPROVE: 'AUTO',
      PARALLEL: 'PARALLEL',
      HIERARCHY: 'HIERARCHY',
    };
    return map[this.type] ?? this.type;
  }
}
